export const LOGIN_WIDGET_DATA = {
    TITLE: "Almost There",
    SUB_TITLE: "Login/Create Account quickly to place order",
    CTA: "Proceed with Phone Number",
    JHS_CTA_TEXT: "Login with OTP",
    JHS_SUB_TITLE: "Login to unlock offers & place order",
    JHS_INFO_TEXT: "Your details are encrypted & [[shared safely]] with Swiggy",
    EXTERNAL_LOGIN_SUB_TITLE: "Login/Create your Swiggy account to place your order",
    EXTERNAL_LOGIN_CTA: "Sign in with Swiggy",
};

export const PRIVACY_POLICY_URI = "/privacy-policy";

export const UNSERVICEABLE_CART_WIDGET_DATA = {
    TITLE: "Currently restaurant is unserviceable",
    CHANGE_ADDRESS: "Change Address",
    USE_ANOTHER_ADDRESS: "Use another address",
    VIEW_SIMILAR: "View similar",
    RESTAURANTS: "Restaurants",
};

export const RESTAURANT_SPECIAL_INSTRUCTIONS = {
    TITLE: "",
    OPT_IN_CONTENT:
        "The restaurant will try their best to fulfill your request, but refund requests in this regard will not be possible",
    OPT_OUT_CONTENT:
        "This restaurant usually does not accept special requests, and refund requests in this regard will not be possible.",
};

export const CART_ITEMS_WIDGET = {
    ADD_MORE_ITEMS: "Add more items",
    ADD_MORE_ITEMS_WITH_SAVING: "Add items worth {0} to save {1}",
};

// export const TURBO_PAY_TOOLTIP_COMMS = "Single click flow is disabled as bill value is more than ₹2000.";

export const CROSS_SELL_ON_CART = {
    ADD_DRINKS: "Add Drinks",
    ADD_DESSERT: "Add Desserts",
    MINI_DRINKS: "portal/m/Juice",
    MINI_DESSERT: "portal/m/cake",
    DESSERT: {
        MAIN_TEXT: "Satisfy your sweet tooth",
        SUB_TEXT: "Add Desserts",
        IMAGE_URL: "portal/m/Desserts_compostion.png",
    },
    DRINKS: {
        MAIN_TEXT: "Missing freshness in your meal",
        SUB_TEXT: "Add Drinks",
        IMAGE_URL: "portal/m/Drinks_compostion.png",
    },
};

export const B2C_TEXTS = {
    BALANCE_TEXT: "Balance: ₹{0}",
    LOW_BALANCE_TEXT: "Balance: ₹{0} (Low)",
};
